import posthog from "posthog-js";
import { toast } from "sonner";

export const logError = (message: string | Error): void => {
  // Don't make network requests during tests
  if (process.env.NODE_ENV === "test") {
    // biome-ignore lint/suspicious/noConsole: <explanation>
    console.error(message);
    return;
  }

  if (process.env.NODE_ENV !== "development") {
    posthog.capture("error", {
      message: message instanceof Error ? message.message : message,
    });
  } else {
    // biome-ignore lint/suspicious/noConsole: <explanation>
    console.error(message);
  }
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const toastError = (title: string, error: any): void => {
  logError(error);
  toast.error(title, {
    description: (error instanceof Error && error.message) || "Unknown error",
    closeButton: true,
  });
};
